export default "__VITE_ASSET__ADDv6h2O__"